import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b6825d8a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=b6825d8a&prod&lang=less"
import style1 from "./Index.vue?vue&type=style&index=1&id=b6825d8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.46.0__css-load_ecc709542230bcceb67dd6366ef941ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6825d8a",
  null
  
)

export default component.exports